module.exports = __webpack_public_path__ + "static/media/4 CCCS meeting 2015.f55264e8.pdf";